import { render, staticRenderFns } from "./RoleStaffList.vue?vue&type=template&id=71f67bca&"
import script from "./RoleStaffList.vue?vue&type=script&lang=js&"
export * from "./RoleStaffList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports